import React from 'react';
import { IMAGES, SITE } from '../mock';
import ServicePage from '../components/ServicePage';
import SEO, { serviceSchema } from '../components/SEO';

export default function Vorsorge() {
  return (
    <>
      <SEO
        path="/vorsorge"
        title="Verlorenes Vorsorgegeld finden – 2. Säule Schweiz"
        description="16 Milliarden CHF liegen auf Schweizer Freizügigkeitskonten ungenutzt. Finde in 3 Minuten kostenlos heraus, ob auch du 2. Säulen-Gelder vergessen hast."
        schema={serviceSchema({ name: 'Vorsorgegeld finden', description: 'Kostenlose Suche nach verlorenem Vorsorgegeld auf Schweizer Freizügigkeitskonten.', url: '/vorsorge' })}
      />
      <ServicePage
      excludeId="vorsorge"
      kicker="Vorsorgegeld finden"
      title="Finde dein verlorenes"
      titleAccent="Vorsorgegeld"
      hero={IMAGES.vorsorge}
      lead="Auf Freizügigkeitskonten liegen rund 16 Milliarden Schweizer Franken ungenutzt. Finde in wenigen Klicks heraus, ob auch Du auf Deinem Lebensweg 2. Säulen Gelder verloren hast."
      bullets={[
        'Kostenlos & innert 3 Minuten',
        'Sofort online prüfen',
        'Im Ø 12’838 CHF pro Person',
        'Auch für frühere Anstellungen in der Schweiz',
      ]}
      ctaPrimary={{ label: 'Vorsorgegelder suchen', href: SITE.vorsorgegeldUrl, external: true }}
      body={[
        'Diverse Lebensereignisse wie <span class="text-[#e8d5a8]">Jobwechsel</span>, <span class="text-[#e8d5a8]">Umzug ins Ausland</span> oder der Wechsel von einer Pensionskasse zur anderen führen oft dazu, dass diese Mittel vergessen werden. Mit unserem kostenlosen Tool findest du innert weniger Klicks heraus, ob auch du noch ausstehende 2. Säulen Gelder hast.',
        'Die Zusammenarbeit mit Partnerfirmen, die auf die Suche und Verwaltung solcher Vermögenswerte spezialisiert sind, ermöglicht es, diese finanziellen Ressourcen zu lokalisieren und wieder in den aktiven Investitionskreislauf einzubinden. Ziel: das gefundene Kapital auf nachhaltige und <span class="text-[#e8d5a8]">rentable Weise</span> anzulegen.',
        '<span class="text-[#e8d5a8]">Im Durchschnitt hat jeder Bürger zwischen 25 und 65 Jahren einen Freizügigkeitsbetrag von 12’838 CHF.</span> Wichtig: Nimm dir Zeit und fülle den Antrag in einem Zug aus, um Datenverluste zu vermeiden. Dieses Angebot gilt nur für Personen, die in der Schweiz erwerbstätig sind oder waren.',
      ]}
      />
    </>
  );
}
